import Dinero from 'dinero.js';

const currencyFormat = process.env.POI_APP_CURRENCY_FORMAT || '$0,0.00';
const currencySymbol = process.env.POI_APP_CURRENCY_SYMBOL || null;
const currencyPosition = process.env.POI_APP_CURRENCY_POSITION || 'START';
const currencySeparator = process.env.POI_APP_CURRENCY_SEPARATOR || null;

const join = (...params) => (separator = ' | ') => {
  return params.filter(param => !!param).join(separator);
};

const formatPrice = ({ price, currency } = {}) => {
  // string value will be `price not found` so return that to display
  if (typeof price === 'string') return price;

  const amount = Math.round((price || 0) * 100);
  const options = { amount };
  const formattedPrice = Dinero(currency ? { ...options, currency } : options).toFormat(
    currencyFormat,
  );

  if (!currencySymbol) return formattedPrice;

  const customFormatPrice = currencySeparator
    ? formattedPrice.replace(/,/g, currencySeparator)
    : formattedPrice;

  return currencyPosition === 'START'
    ? `${currencySymbol}${customFormatPrice}`
    : `${customFormatPrice}${currencySymbol}`;
};

const round = value => Math.round(value * 100) / 100;

const formatAmountInCents = ({ amount }) => Math.round((amount * 100 + Number.EPSILON) * 100) / 100;

const signaledFormatPrice = ({ formatPrice: formatter = () => {}, price }) => {
  return `${price > 0 ? '+' : ''}${formatter({ price })}`;
};

const capitalizeFirstLetter = fullName => {
  return fullName
    .split(' ')
    .map(name => name.charAt(0).toUpperCase() + name.slice(1))
    .join(' ');
};

export {
  join,
  formatPrice,
  round,
  formatAmountInCents,
  signaledFormatPrice,
  capitalizeFirstLetter,
};
